import axios from 'axios';
import {
  alert,
  PHP
} from './store';
import {
  values
} from 'ramda';

const phpData = () => {
  let config;

  PHP.subscribe(c => config = c);

  return config;
};

const request = async (method, url, dataOrParams, options = {}) => {
  const {
    baseUrl,
    headers: customHeaders
  } = options;
  const PHP = phpData();

  try {
    return await axios.request({
      method,
      timeout: 60000,
      baseURL: baseUrl || PHP.baseUrl,
      url,
      headers: {
        accept: 'application/json',
        ...PHP.headers,
        ...customHeaders,
      },
      [method === 'get' ? 'params' : 'data']: dataOrParams,
    });
  } catch (error) {
    let err;

    if ((error.response || {}).data) {
      err = values(error.response.data);
      if (Array.isArray(err)) err = err[0];
    } else if (error.message) {
      err = error.message;
    } else {
      err = "something went wrong" + error;
    }

    alert.setWithTimeout({
      value: err,
      className: 'is-danger'
    });

    return Promise.reject(err);
  }
};

const get = (url, params, options = {}) => {
  return request('get', url, params, options);
};

const post = (url, data, options = {}) => {
  return request('post', url, data, options);
};

const deleteReq = (url, data, optiosn = {}) => {
  return request('delete', url, data, optiosn);
};

export const retrieveNotifications = ({
  limit,
  offset
} = {}) => {
  const url = `/messaging/notifications/web/`;

  return get(url, {
    limit,
    offset,
    app_id: phpData().app_id
  }, {});
};

export const resendNotification = (wrapperId) => {
  const url = `/messaging/notifications/resend/`;

  return post(url, {
    wrapper_id: wrapperId
  }, {});
};

export const deleteNotification = (wrapperId) => {
  const url = `/messaging/notifications/${wrapperId}`;

  return deleteReq(url, {
    wrapper_id: wrapperId
  }, {});
};

export const uploadIcon = (image) => {
  const url = `/files/icons/`;

  return post(url, image, {});
};

export const uploadImage = (image) => {
  const url = `/files/images/`;

  return post(url, image, {});
};

export const sendNotification = (data) => {
  const url = `/messaging/notifications/web`;

  return post(url, data, {});
};


export const sendActivationEmail = (email, admin_url) => {
  const url = `/plugin/login/create_user`;
  // This url doesn't need authorization header
  const options = {
    headers: {
      Accept: "application/json",
      Authorization: ""
    }
  };
  return post(url, {
    email,
    admin_url
  }, options);
};

export const fetchUpgradeData = () => {
  const url = `/plugin/wordpress/check_billing`;
  return get(url, {}, {});
};

export const saveSettings = async (type, data) => {
  const PHP = phpData();

  return post('', data, {
    baseUrl: PHP.ajaxUrl + `?action=${type}`,
  });
};

export const loadCharts = async () => {
  const PHP = phpData();

  if (!PHP.app_id) {
    return Promise.reject(new Error('App id is required to send request'));
  }

  const url = `/plugin/wordpress/${PHP.app_id}/dashboard/`;

  return get(url, {}, {});
};

export const support = (data) => {
  const url = `/plugin/support`;

  return post(url, data, {});
};